import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { HelmetProvider } from 'react-helmet-async'

import { initSentry } from './utils/sentry'
import { ensureBackendAwake } from './utils/wakeBackend'
import { store } from './store'
import { theme } from './theme'
import App from './App'
import AuthInitializer from './components/auth/AuthInitializer'
import BackendWakeGate from './components/BackendWakeGate'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

initSentry()

// Kick off backend wake as soon as the bundle runs (before React mounts)
if (import.meta.env.MODE !== 'test') {
  void ensureBackendAwake()
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorBoundary>
              <BackendWakeGate>
                <AuthInitializer>
                  <App />
                </AuthInitializer>
              </BackendWakeGate>
            </ErrorBoundary>
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>,
)
